const reducers = {
    setCustomerHistory: (state, param) => {
        const { payload } = param;
        return (state.data = payload);
    },
    clearCustomerHistory: (state) => {
        state.data = {};
    },
};

export default reducers;
